const MAX_LENGTH_CONSTRAINTS = {
  PICKUP_PRO_FORM: {
    ZIP: 6,
    CONSIGNEE_NAME: 30,
    CONSIGNEE_CITY: 20,
    PIECES: 5,
    WEIGHT: 7,
    HAZMAT_WEIGHT: 6,
    EXCESSIVE_LENGTH: 2,
  },
  NO_FREIGHT_FORM: {
    CUSTOMER_NAME: 30,
  },
  DELIVERY_PRO_FORM: {
    DE_COMMENTS: 35,
    PALLET_COUNT: 3,
    SCAC_CODE: 5,
    RECEIVER_NAME : 30,
    RECEIVER_EMAIL : 60,
  },
  SHRINK_WRAP: 999,
  PAYMENT_TYPE: {
    CHECK: 10,
  },
  END_TRIP_FORM: {
    DOOR_OR_YARD: 3,
  }
};

const MAX_VALUE_CONSTRAINTS = {
  PICKUP_PRO_FORM: {
    ZIP: 999999,
    PIECES: 99999,
    HU: 99999,
    WEIGHT: 9999999,
    HAZMAT_WEIGHT: 999999,
    EXCESSIVE_LENGTH: 99,
  },
  DELIVERY_PRO_FORM: {
    PALLET_COUNT: 999,
    ADE_NUMBER: 999999999,
    EXCESSIVE_LENGTH: 999,
    SCAC_CODE: 9999999999,
    DE_PIECES: 99999,
  },
  END_TRIP_FORM: {
    ODOMETER_READING: 9999999,
    DOOR_OR_YARD: 999,
  },
};

const SPECIAL_SYMBOLS = {
  HAZMAT: "X",
};

const MIN_VALUE = {
  PICKUP_PRO_FORM: {
    WEIGHT: 1,
    PIECES: 1,
    EXCESSIVE_LENGTH: 1,
    HU: 1,
  },
  DEFAULT: 0,
  DELIVERY_PRO_FORM: {
    ADD_PRO: 1,
    ADE_NUMBER: 1,
    EXCESSIVE_LENGTH: 8,
    DE_PIECES: 1,
  },
};
const HAZMAT_FORM_CONSTANTS = {
  UN_NUMBER: {
    ERROR_TEXTS: {
      UN_NUMBER_LENGTH_TEXT: "Enter a 4 digit number",
      UN_NUMBER_INVALID_TEXT: "The entered UN number is invalid",
      UN_NUMBER_REQUIRED_TEXT: "UN number is required",
      UN_NUMBER_NOT_SHIPPABLE_TEXT:
        "We does not ship this product. Return this item to shipper",
    },
    WARNING_TEXTS: {
      UN_NUMBER_WARNING_TEXT: "Invalid entry",
    },
  },
  WEIGHT_ERROR_TEXT:
    "Hazmat weight cannot be greater than total weight of the bill",
  BULK_LIST: [
    {
      value: false,
      label: "No",
    },
    {
      value: true,
      label: "Yes",
    },
  ],
  PG_NUMBER_LIST: [
    { label: "None", value: "" },
    { label: "I", value: "I" },
    { label: "II", value: "II" },
    { label: "III", value: "III" },
  ],
  UN_PREFIX: "UN",
};

const PAYMENT_MODES = {
  FREIGHT_PAYMENT_MODES: {
    CASH: "cash",
    CHECK: "check",
    COMPANY_ACCOUNT: "companyAccount",
    FREIGHT_PAYMENT_MODELIST: [
      { description: "Cash", code: "cash" },
      { description: "Check", code: "check" },
      { description: "Company Account", code: "companyAccount" },
    ],
  },
  COD_PAYMENT_MODES: {
    CERTIFIED_CHECK: "certifiedCheck",
    COMPANY_CHECK: "companyCheck",
    COD_PAYMENT_MODELIST: [
      { description: "Certified Check/ Money Order", code: "certifiedCheck" }, // Money Order
      { description: "Company Check", code: "companyCheck" },
    ],
  },
};

const HAZMAT_EMERGENCY_NUMBER = "8004249300";

const CUSTOMER_CONFIG = {
  SAIA: "SAIA",
  DEFAULT: "DEFAULT",
  SMT : "SMT"
};

const EXCEPTION_CODE = {
    DELIVERY_DAMAGED:"DD",
    DELIVERY_SHORT:"DS",
    DELIVERY_OVER:"DO",
    PARTIALLY_REFUSED:"PR"
}

export {
  MAX_LENGTH_CONSTRAINTS,
  HAZMAT_FORM_CONSTANTS,
  PAYMENT_MODES,
  MIN_VALUE,
  MAX_VALUE_CONSTRAINTS,
  SPECIAL_SYMBOLS,
  HAZMAT_EMERGENCY_NUMBER,
  CUSTOMER_CONFIG,
  EXCEPTION_CODE,
};
